/* eslint-disable react-hooks/refs */
import type { ComponentProps } from 'react';
import type React from 'react';

import { FloatingArrow, FloatingPortal } from '@floating-ui/react';

import { cn } from '@change/ds-utils';

import { useTooltipContext } from '../hooks/context';

export const TooltipContent: React.FC<ComponentProps<'div'>> = ({ children, className, ...props }) => {
	const context = useTooltipContext();

	if (!context.open) return null;

	return (
		<FloatingPortal>
			<div
				ref={context.refs.setFloating}
				className={cn(
					// eslint-disable-next-line @change-ds/ds-no-raw-color-classname -- tooltip stays black in both modes (no fixed fill token)
					'border-stroke-info-weak text-typography-inverse-strong-fixed max-w-[400px] min-w-min rounded-md border border-solid bg-black p-4',
					className,
				)}
				style={context.floatingStyles}
				{...context.getFloatingProps(props)}
				aria-live="polite"
			>
				<FloatingArrow ref={context.arrowRef} context={context.context} fill="var(--color-stroke-info-weak)" />
				{children}
			</div>
		</FloatingPortal>
	);
};
